import { FilterConfig, radioButtonSplit } from '../../../../model/filter';
import {AppsFilterNames} from '../../../../utils/enums';
import {AppWithStatus} from '../../../../dtos/app.dto';
import {useStores} from '../../../store';

export const useAppsFiltersConfig = (): FilterConfig<AppWithStatus> => {
    const {customerStore} = useStores();
    const isPremium = customerStore.isPremium;

    const options = [
        {label: AppsFilterNames.All, filterFn: () => true},
        {label: AppsFilterNames.Blocked, filterFn: (app: AppWithStatus) => !app.inboundAllowed || !app.outboundAllowed},
        {label: AppsFilterNames.Allowed, filterFn: (app: AppWithStatus) => app.inboundAllowed || app.outboundAllowed},
        ...(isPremium ?
            [{label: radioButtonSplit, filterFn: () => true}, {label: AppsFilterNames.AiDefense, filterFn: () => true}] :
            [])
    ];

    return {
        searchBox: {placeholder: 'Search Apps', byFields: ['displayName', 'description']},
        localStorageKey: 'appsFilter',
        radioButtons: {
            defaultSelectionIndex: 0,
            options
        }
    };
};